import React, { useState } from 'react';
import { connect } from 'react-redux';
import LayerA from '~/components/Layers/LayerA/LayerA';
import LayerB from '~/components/Layers/LayerB/LayerB';
import LayerD from '~/components/Layers/LayerD/LayerD';
import scrollAnimation from '~/utils/scroll-animation';
import css from './Card.less';

const Card = props => {
  const [layerData, setLayerData] = useState({
    visible: false,
    msg: '扫描上方二维码',
    desc: '微信扫描小程序，立即购买',
  });

  const [layerDataB, setLayerDataB] = useState({
    visible: false,
    desc: '扫描二维码，添加专属小助理',
  });

  const [layerDataD, setLayerDataD] = useState({
    visible: false,
    address: {},
  });

  const showLayer = () => {
    setLayerData({
      ...layerData,
      visible: true,
    });
  };

  const hideLayer = () => {
    setLayerData({
      ...layerData,
      visible: false,
    });
  };

  const showLayerB = () => {
    setLayerDataB({
      ...layerDataB,
      visible: true,
    });
  };

  const hideLayerB = () => {
    setLayerDataB({
      ...layerDataB,
      visible: false,
    });
  };

  const showLayerD = item => {
    setLayerDataD({
      ...layerDataD,
      visible: true,
      address: item,
    });
  };

  const hideLayerD = () => {
    setLayerDataD({
      ...layerDataD,
      visible: false,
    });
  };

  const switchTab = id => {
    const tabElement = document.getElementById(id);
    if (id && tabElement) {
      const targetY = tabElement.offsetTop + 120 || 0;
      scrollAnimation(targetY);
    }
  };

  const { tuan } = props;
  const { product, customerService } = tuan;
  return (
    <div className={css.contentMain}>
      <div
        className={`bg-cover ${css.avatar}`}
        style={{ backgroundImage: `url(${product.cover_url})` }}
      >
        {' '}
      </div>

      <div>
        <h1 className={`text-hidden-2 ${css.title}`}>{product.title}</h1>

        {product.labels && product.labels.length ? (
          <p className={css.tags}>
            {product.labels.map(item => {
              return (
                <span key={item.toString()} className={css.tag}>
                  {item}
                </span>
              );
            })}
          </p>
        ) : null}

        <p className={css.pricebox}>
          <span className={css.unit}>¥</span>
          <span className={`dinBold ${css.price}`}>{product.price}</span>
          {product.market_price ? (
            <span className={css.original}>¥{product.market_price}</span>
          ) : null}
        </p>

        {product.at_your_door ? (
          <p className={`text-hidden-one ${css.mode}`}>
            服务方式：{product.at_your_door_rule}
          </p>
        ) : null}

        {product.shops && product.shops.length ? (
          <div className={css.bottom}>
            <p className={css.shopsTitle}>商户地址</p>
            <ul>
              {product.shops.map((item, index) => {
                return (
                  <React.Fragment key={item.id.toString()}>
                    {index <= 1 ? (
                      <li className={css.shop} onClick={() => showLayerD(item)}>
                        <span>
                          {item.short_name || item.name}：
                          {item.short_address || item.address}
                        </span>{' '}
                        {item.distance || ''}
                      </li>
                    ) : null}
                  </React.Fragment>
                );
              })}
            </ul>
            {product.shops && product.shops.length >= 3 ? (
              <p className={css.btn} onClick={() => switchTab('shops')}>
                查看全部{product.shops.length}个分店
              </p>
            ) : null}
          </div>
        ) : null}
      </div>

      <div className={`flex-space-between ${css.btns}`}>
        <button type="button" className="xd-btn" onClick={() => showLayer()}>
          立即抢购
        </button>
        <button
          type="button"
          className={`xd-btn ${css.assistant}`}
          onClick={() => showLayerB()}
        >
          咨询客服
        </button>
      </div>
      {/* 立即抢购弹窗 */}
      <LayerA
        visible={layerData.visible}
        qrcode={product.xcx_qrcode_url || ''}
        msg={layerData.msg}
        desc={layerData.desc}
        showLayer={showLayer}
        hideLayer={hideLayer}
      />
      {/* 联系小助理弹窗 */}
      <LayerB
        visible={layerDataB.visible}
        qrcode={customerService.qrcode}
        msg={customerService.nickname}
        desc={layerDataB.desc}
        showLayer={showLayerB}
        hideLayer={hideLayerB}
      />
      {/* 门店地图 */}
      <LayerD
        visible={layerDataD.visible}
        address={layerDataD.address}
        showLayer={showLayerD}
        hideLayer={hideLayerD}
      />
    </div>
  );
};

export default connect(({ tuan }) => ({
  tuan,
}))(Card);
